import i18n from '@/lang/index'
export const addColumns = [
    {
        prop: 'goodsNo',
        label: i18n.t('invoicesCenter.outconfigGoodsno')
    },
    {
        prop: 'goodsCode',
        label: i18n.t('invoicesCenter.outconfigGoodscode')
    },
    {
        prop: 'goodsName',
        label: i18n.t('invoicesCenter.outconfigGoodsname')
    },
    {
        prop: 'colorValue',
        label: i18n.t('invoicesCenter.outconfigColorvalue')
    },
    {
        prop: 'sizeInfoList',
        width: '800px',
        boxWidth: '1px' //复选框宽度
    },
    {
        prop: 'total',
        label: i18n.t('invoicesCenter.outconfigTotal'),
        type: 'count',
        getTotal(row, _key) {
            return row.sizeInfoList.reduce((c, R) => c + Number(R[_key] ? R[_key] : 0), 0)
        }
    },
]

export const addSizeInfoLabel = [
    {
        prop: 'num', //复选框key//valueInfoList当前行对应key
        label: '', //复选框名称及行数据对应名称
        checkShow: false, //是否出现复选框
        value: true, //绑定值
        disabled: true //禁用
    }
]